import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-faqs',
  imports: [
    NgFor,
    NgClass,
    NgIf,
    DynamicModule,
    StoryblokLinkDirective,
    StoryblokDirective,
  ],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss',
})
export class FaqsComponent {
  @Input() accordions!: any[];
  @Input() title!: any[];
  @Input() link_text: any;
  @Input() link: any;
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
  components: any;

  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }
}
